export default {"src":"/_next/static/media/arrow_out.8e8245ba.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};